'use client'

import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { FormEvent, useState } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'
import { IconButton } from '@/shared/ui/IconButton'

import { TopBannerData } from '../types/types'

import cl from './TopBanner.module.scss'

type Props = {
	data: TopBannerData
}

export const TopBanner = ({ data }: Props) => {
	const [isBannerClosed, setIsBannerClosed] = useState(false)

	if (isBannerClosed) return null

	const onClose = (e: FormEvent<HTMLButtonElement>) => {
		e.preventDefault()
		setIsBannerClosed(true)
	}

	return (
		<div id="banner" className={clsx(cl.root, `js-topBanner`)}>
			<Link prefetch={false} href={data.LINK_VALUE}>
				{/* Both crops are rendered into the SSR HTML and toggled with CSS media queries (not JS),
				    so the correct image is in the initial markup and can be preloaded. Picking the src on
				    the client (useMediaQueries) meant the mobile image only loaded after hydration, adding
				    ~0.8s of LCP load delay on mobile. `priority` on the mobile crop preloads the mobile
				    LCP; the desktop crop stays lazy so it isn't fetched on mobile.
				    sizes="100vw": the strip spans the viewport; a larger value over-fetches the srcset. */}
				<div className={cl.desktop}>
					<Image
						src={BASE_URL + data.BANNER_IMAGE_DESC}
						quality={75}
						height={240}
						width={9600}
						sizes="100vw"
						alt={data.NAME}
					/>
				</div>
				<div className={cl.mobile}>
					<Image
						src={BASE_URL + data.BANNER_IMAGE_MOBILE}
						quality={75}
						height={240}
						width={9600}
						sizes="100vw"
						alt={data.NAME}
						priority
					/>
				</div>
			</Link>
			<IconButton aria-label="Скрыть" className={cl.close} icon="Close" onClick={onClose} />
		</div>
	)
}
